import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { ActionIcon, Group, Paper, Text } from '@mantine/core'
import { IconGripVertical, IconTrash } from '@tabler/icons-react'

interface SortableItemProps {
  id: string
  onRemove: (id: string) => void
}

export function SortableItem({ id, onRemove }: SortableItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Paper
      ref={setNodeRef}
      style={{ ...style, cursor: 'grab', marginBottom: '8px' }}
      {...attributes}
      withBorder
      p="sm"
      component="li"
    >
      <Group justify="space-between" align="center">
        <Group gap="xs">
          <div {...listeners}>
            <IconGripVertical data-test-id="DD-Summarizer-Drag-Item" size={16} color="gray" />
          </div>
          <Text size="sm">{id}</Text>
        </Group>
        <ActionIcon
          data-test-id="DD-Summarizer-Delete-Item"
          variant="transparent"
          c="gray.6"
          size="sm"
          radius="xl"
          className="close-icon-hover"
          onClick={(e: any) => {
            e.stopPropagation()
            onRemove(id)
          }}
        >
          <IconTrash size={14} color="red" />
        </ActionIcon>
      </Group>
    </Paper>
  )
}
